// extracted by mini-css-extract-plugin
export default {"_":"FinancialActivationLabel____dsbca","text":"FinancialActivationLabel_text__ckGw2","icon":"FinancialActivationLabel_icon__GbIxT"};